import { decibelToGain } from './decibels';
import { getAudioFadeMultiplier } from './get-audio-fade-multiplier';

export const volumeFn =
  ({
    fps,
    audioFadeInDurationInSeconds,
    audioFadeOutDurationInSeconds,
    durationInFrames,
    decibelAdjustment,
    fadeWindow,
  }: {
    fps: number;
    audioFadeInDurationInSeconds: number;
    audioFadeOutDurationInSeconds: number;
    durationInFrames: number;
    decibelAdjustment: number;
    fadeWindow?: {startInSeconds:number;endInSeconds:number};
  }) =>
  (frame: number) => {
    const fadeMultiplier = getAudioFadeMultiplier({
      frame:frame-(fadeWindow?.startInSeconds??0)*fps,
      fadeInFrames: audioFadeInDurationInSeconds * fps,
      fadeOutFrames: audioFadeOutDurationInSeconds * fps,
      durationInFrames: fadeWindow?(fadeWindow.endInSeconds-fadeWindow.startInSeconds)*fps:durationInFrames,
    });

    // fade 효과와 volume 조정을 결합
    const baseVolume = decibelToGain(decibelAdjustment);
    const finalVolume = baseVolume * fadeMultiplier;
    return finalVolume;
  };
